import styled from 'styled-components';

export const Container = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 24px 28px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
  }

  h3 {
    color: #222;
    font-weight: 700;
    font-size: 1rem;
    user-select: none;
  }

  .details-link {
    color: #2f4bff;
    font-size: 0.85rem;
    font-weight: 500;
    text-decoration: underline;
    cursor: pointer;
    user-select: none;
  }

  .cards {
    display: flex;
    flex-direction: column;
  }

  .wrapper {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 16px 0;
    border-bottom: 1px solid #f1f5f9;
    transition: background-color 0.2s ease;

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }

    &:first-child {
      padding-top: 0;
    }

    &:hover {
      background-color: #fafafa;
    }
  }

  .position {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: #e6ecff;
    color: #2f4bff;
    font-weight: 700;
    font-size: 0.8rem;
    flex-shrink: 0;
    user-select: none;
  }

  .img {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 52px;
    height: 52px;
    border-radius: 10px;
    background-color: #e2e8f0;
    overflow: hidden;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }

    svg {
      color: #94a3b8;

      &.hidden {
        display: none;
      }
    }
  }

  .description {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;

    .name {
      font-weight: 700;
      font-size: 0.9rem;
      color: #1f2937;
      text-transform: capitalize;
      user-select: text;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .category {
      font-size: 0.8rem;
      color: #9ca3af;
      margin-top: 2px;
      user-select: none;
    }
  }

  .details {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 2px;
    flex-shrink: 0;

    .sales {
      font-weight: 700;
      font-size: 0.9rem;
      color: #1f2937;
      user-select: none;
    }

    .qtd {
      font-size: 0.8rem;
      color: #2f4bff;
      font-weight: 600;
      user-select: none;
    }
  }

  .not-data {
    text-align: center;
    padding: 4rem 0;
    color: #9ca3af;
    font-weight: 600;
    font-size: 0.9rem;
    user-select: none;
  }
`;
